// src/components/TeamMemberCard.js
import React from 'react';

const TeamMemberCard = ({ initials, name, role, description, github, discord, twitter, imageUrl }) => {
  return (
    <div className="glass-card p-5 rounded-xl team-card transition duration-300">
      <div className="flex flex-col items-center text-center">
        <div className="w-32 h-32 rounded-full bg-gradient-to-br from-devore.primary to-blue-400 mb-6 overflow-hidden">
          {/* Conditional rendering: if imageUrl is provided, show image, otherwise show initials */}
          {imageUrl ? (
            <img src={imageUrl} alt={name} className="w-full h-full object-cover rounded-full" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-white text-4xl font-bold">{initials}</div>
          )}
        </div>
        {/* Name: Blue color with a subtle glowing text shadow */}
        <h3
          className="text-xl font-semibold mb-2 text-devore.primary" // Keeps the primary blue color
          style={{ textShadow: '0 0 8px rgba(49, 109, 174, 0.6), 0 0 15px rgba(49, 109, 174, 0.3)' }} // Custom glow effect
        >
          {name}
        </h3>
        {/* Role: Styled as a tag with a subtle background and border */}
        <p className="px-3 py-1 bg-white/10 border border-white/20 rounded-full text-gray-200 text-sm mb-4 inline-block">
          {role}
        </p>
        <p className="text-gray-300 mb-4">{description}</p>
        <div className="flex space-x-4">
          <a href={github} className="text-gray-300 hover:text-devore.primary transition" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-github"></i>
          </a>
          <a href={discord} className="text-gray-300 hover:text-devore.primary transition" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-discord"></i>
          </a>
          {/* Twitter link commented out as in your provided code */}
          {/* <a href={twitter} className="text-gray-300 hover:text-devore.primary transition" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-twitter"></i>
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default TeamMemberCard;